import ReactCollapse from './ReactCollapse';

export default ReactCollapse;
